<div class="skills-tags">
    <ng-container *ngIf="hasSkills(profile)">
        <div class="quality-tag" *ngFor="let quality of getAllQualities(profile)">
            <span class="quality-name">
                {{ quality.name }}
            </span>
            <app-digit-dropdown [(model)]="quality.userLevel" [disabled]="isSortable"
                (modelChange)="qualityLevelChanged(quality.qualityId, $event)" [textboxWidth]="'24px'">
            </app-digit-dropdown>
            <button class="remove-quality-btn" type="button" (click)="removeQualityClicked(quality.qualityId)"
                [disabled]="!canEditUsers || isSortable" aria-label="Remove Quality">
                <i class="fal fa-times"></i>
            </button>
        </div>
    </ng-container>
    <app-basic-button type="primary" isIcon="true" size="small" class="add-skills-button" (click)="addSkillsClicked()"
        [disabled]="!canEditUsers || isSortable">
        <i class="fal fa-plus"></i>
    </app-basic-button>
</div>